import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from '../../../types/product';
import { Features } from '../../../types/features';
import { ProductDetailRouteService } from '../../../services/product-detail-route.service';


@Component({
    selector: 'app-cross-product-card',
    templateUrl: './cross-product-card.component.html',
    styleUrls: ['./cross-product-card.component.scss'],
    standalone: false
})
export class CrossProductCardComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private productDetailRoute: ProductDetailRouteService,
  ) {}

  @Input() product!: Product;
  @Input() categoryId!: number;
  @Input() isVoteVisible = false;
  @Input() featureFlags?: Features = {};
  @Input() categorizationSchemeId = NaN;

  get totalCrossesCount() {
    return this.product?.statistics?.crossReferenceStatistic?.crossCount || 0;
  }
  get upCount() {
    return this.product?.statistics?.crossReferenceStatistic?.approveCount || 0;
  }
  get downCount() {
    return this.product?.statistics?.crossReferenceStatistic?.disputeCount || 0;
  }

  get productUrl() {
    return this.productDetailRoute.get(
      {
        categorizationSchemeId: this.categorizationSchemeId,
        categoryId: this.categoryId,
        productId: this.product.id,
        productSource: this.product.productSource,
      },
      { features: this.featureFlags },
    );
  }

  ngOnInit(): void {}
  
}
